import React from 'react';

import './AuthPanel.css';

function AuthPanel({
  eyebrow = 'Account',
  title,
  description,
  children,
  width = 'narrow',
}) {
  return (
    <section className="auth-panel-page">
      <div className={`container auth-panel-container ${width === 'wide' ? 'is-wide' : ''}`}>
        <div className="card auth-panel-card shadow-sm">
          <div className="card-body auth-panel-body">
            {eyebrow && <p className="auth-panel-eyebrow">{eyebrow}</p>}
            <h1 className="auth-panel-title">{title}</h1>
            {description && <p className="auth-panel-description">{description}</p>}
            {children}
          </div>
        </div>
      </div>
    </section>
  );
}

export default AuthPanel;
